'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDeleteForever = function ActionDeleteForever(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' })
  );
};
ActionDeleteForever = (0, _pure2.default)(ActionDeleteForever);
ActionDeleteForever.displayName = 'ActionDeleteForever';
ActionDeleteForever.muiName = 'SvgIcon';

exports.default = ActionDeleteForever;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/delete-forever.js
// module id = 1795
// module chunks = 0